'use strict';

import { doAjaxFiltering } from './modules/filter';
import { DOM } from './modules/init';
import { enablePaginationEvents } from './modules/pagination';

const form = document.querySelector('form.blog__controls');
if (form) {
	// Add an event listener to all form elements that are not hidden <input> elements
	[...form.elements].forEach((element) => {
		if (element.name.includes('filter_') && !(element.type && element.type === 'hidden')) {
			element.addEventListener('change', doAjaxFiltering);
		}
	});
}

// Add pagination event handler
document.addEventListener('afterPaginationInit', enablePaginationEvents);

// Reset filters
document.addEventListener(
	'click',
	function (e) {
		// loop parent nodes from the target to the delegation node
		for (let target = e.target; target && target != this; target = target.parentNode) {
			if (target.matches('.postfilter__reset')) {
				document.querySelector(DOM.form).reset();
				doAjaxFiltering();
				break;
			}
		}
	},
	false,
);
